export const cardStateName = "card";

export const cardInitialState = {
  card: { title: null, cardID: null, ID: null, billingID: null, loading: false },
};
